import Link from 'next/link'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import Alert from '@mui/material/Alert'

const Disclaimer = () => {
  return (
    <>

      <Grid container spacing={6}>
        <Grid size={{ xs: 12 }}>
          <Card
            sx={{
              padding: '2rem',
              borderRadius: '12px',
              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
              borderTop: '6px solid',
              borderTopColor: 'primary.main'
            }}
          >
            <Typography variant='h4' component='h1' color='primary' gutterBottom>
              Disclaimer
            </Typography>
            <Divider sx={{ mb: 3 }} />

            <Box sx={{ maxWidth: 800 }}>
              <Alert severity='info' sx={{ mb: 3 }}>
                WAO Tools is an independent, fan-made project and is <strong>not</strong> affiliated with,
                endorsed by, sponsored by, or officially connected to the publishers or developers of War and
                Order in any way.
              </Alert>

              <Typography variant='h6' component='h2' color='primary' gutterBottom>
                Fan-Made Project
              </Typography>
              <Typography variant='body1' paragraph>
                WAO Tools was created independently by a player of War and Order as a free community resource.
                The site has no official relationship with the game's publisher or development team. We are not
                representatives of the game, and nothing on this site should be interpreted as official game
                guidance, announcements, or support.
              </Typography>

              <Typography variant='h6' component='h2' color='primary' gutterBottom>
                Trademarks and Game Assets
              </Typography>
              <Typography variant='body1' paragraph>
                "War and Order" and all associated game names, logos, characters, troop names, mechanics, and
                in-game assets are trademarks and intellectual property of their respective owners. WAO Tools
                makes no claim of ownership over any game content. All references to game mechanics, items, or
                features are purely for informational and community-support purposes.
              </Typography>

              <Typography variant='h6' component='h2' color='primary' gutterBottom>
                Accuracy of Information
              </Typography>
              <Typography variant='body1' paragraph>
                The calculators and reference data on WAO Tools are based on community research, player-contributed
                data, and direct in-game observations. While we strive for accuracy, War and Order is a live game
                that updates regularly. Tool data may not always reflect the latest game state. Always verify
                critical information in-game before making important decisions.
              </Typography>
              <Typography variant='body1' paragraph>
                WAO Tools provides all content for informational and planning purposes only. We make no guarantee
                that calculations, data tables, or strategic suggestions on this site will produce specific outcomes
                in the game.
              </Typography>

              <Typography variant='h6' component='h2' color='primary' gutterBottom>
                Advertising
              </Typography>
              <Typography variant='body1' paragraph>
                This site displays advertisements via Google AdSense. Advertisers have no influence over the tools
                or content provided on WAO Tools. For more information on how advertising data is handled, see our{' '}
                <Link href='/privacy/' style={{ color: 'inherit' }}>
                  Privacy Policy
                </Link>
                .
              </Typography>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </>
  )
}

Disclaimer.noLoadingGate = true

export default Disclaimer

